import { FiTaskV2ReportHelperService } from './../../services/fi-task-v2-report-helper.service';
import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation, inject, input } from '@angular/core';
import { ITask2ReportAvailableItems, ITask2ReportWidget, ITask2ReportWidgetFilter } from '../../fi-task-v2-report';
import { FiTaskReportType } from '../../fi-task-v2-report-enums';
import { NewWidgetFilterSettingsDialogBaseDirective } from '@fi-shared/fi-report-widget/new-report-widget-dialog/new-widget-filter-settings-dialog-base';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-new-widget-data-filter-step',
    templateUrl: './new-widget-data-filter-step.component.html',
    styleUrls: ['./new-widget-data-filter-step.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-widget-data-filter-step' },
    standalone: false,
})
export class NewWidgetDataFilterStepComponent extends NewWidgetFilterSettingsDialogBaseDirective<
    ITask2ReportWidgetFilter,
    FiTaskReportType,
    ITask2ReportWidget
> {
    public availableItems = input.required<ITask2ReportAvailableItems>();

    private fiTaskV2ReportHelperService = inject(FiTaskV2ReportHelperService);
    private appTextService = inject(AppTextService);

    protected widgetName = computed(() =>
        this.appTextService.get(
            this.fiTaskV2ReportHelperService.getTaskReportNameByReportType(this.reportWidget().ReportType),
        ),
    );
}
